import React, { memo, forwardRef } from "react";
const SvgNumberone = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M17.22 11.44l-2.04 1.68a1.794 1.794 0 01-.44.24c-.147.04-.273.06-.38.06-.293 0-.54-.1-.74-.3-.2-.2-.3-.453-.3-.76 0-.147.04-.3.12-.46.08-.173.227-.347.44-.52L17 8.86c.253-.2.473-.333.66-.4.2-.08.38-.12.54-.12.12 0 .26.02.42.06.173.027.333.1.48.22.147.107.267.267.36.48.107.213.16.493.16.84v11.58c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.909.909 0 01-.4.18 1.22 1.22 0 01-.34.06 1.43 1.43 0 01-.36-.06 1.064 1.064 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7V11.44z"
      />
    </svg>
  );
});
SvgNumberone.displayName = "SvgNumberone";
const MemoForwardRef = memo(SvgNumberone);
export default MemoForwardRef;
